import React from "react";
import {Button, ClosePopupButton, GridItem, Heading, Icon} from "../index";
import {classNames} from "../../tools/react.dom.helpers";
import ModalMobileCloseBtn from "./ModalMobileCloseBtn";
import Grid from "../grid";
import {Visible} from "../../component/visible";

const ModalHeader = ({className, title, children, onClick, showCloseBtn = true, ...otherProps}) => (
    <>
        <Visible visible={showCloseBtn}>
            <ModalMobileCloseBtn/>
        </Visible>
        <div className={classNames('modal-header', className && className)}>
            <Grid className={'modal-header__grid'} gapX={Grid.GAP.GAP_16} breakpoint={false} justify={Grid.JUSTIFY.START} align={Grid.ALIGN.BASELINE}>
                <GridItem className={'modal-header__grid_item-content'}>
                    {title && <Heading className={'modal-title'} type={Heading.TYPE.H3} title={title}/>}
                    {children}
                </GridItem>
                <Visible visible={showCloseBtn}>
                    <GridItem fitByContent>
                        <ClosePopupButton template={Button.TEMPLATE.ACTION} icon={Icon.ICON.CLOSE} onClick={onClick} {...otherProps}/>
                    </GridItem>
                </Visible>
            </Grid>
        </div>
    </>

);

export default ModalHeader;